import { CareerPostingType } from 'models/career';
import { createContext, useContext } from 'react';

export type CreatePositionFormType = {
  jobTitle: string;
  department: string;
  workMode: string;
  location: string;
  roleSummary: string;
  responsibilities: string;
  qualifications: string;
  applicationDeadline: string;
  noOfOpenings: string;
  applicationLink: string;
  experience: string;
  status: string;
};

export type NewCareerPositionContextType = {
  createJobPositionForm: CreatePositionFormType;
  setCreateJobPositionForm: (k: CreatePositionFormType) => void;
  disabled: boolean;
  setDisabled: (k: boolean) => void;
  selectedJob?: CareerPostingType;
  loadingJob: boolean;
};

export const NewCareerPositionContext = createContext({} as NewCareerPositionContextType);

const useNewCareerPositionContext = () => {
  const context = useContext(NewCareerPositionContext);
  return context;
};

export default useNewCareerPositionContext;
